/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EMessageFilterAction = 'HasMessage' | 'All';

export const EMessageFilterAction = {
    HasMessage: 'HasMessage' as EMessageFilterAction,
    All: 'All' as EMessageFilterAction
};

